export enum UserRole {
  SYSTEM = 'SYSTEM',
  PATIENT = 'PATIENT',
  COUNSELLOR = 'COUNSELLOR',
  SUPERVISOR = 'SUPERVISOR',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  RESEARCHER = 'RESEARCHER',
  EMERGENCY_RESPONDER = 'EMERGENCY_RESPONDER'
}

export enum Permission {
  VIEW_USERS = 'VIEW_USERS',
  INVITE_USER = 'INVITE_USER',
  CHANGE_USER_ROLE = 'CHANGE_USER_ROLE',
  DELETE_USER = 'DELETE_USER',
  VIEW_CASES = 'VIEW_CASES',
  VIEW_SESSIONS = 'VIEW_SESSIONS',
  VIEW_COUNSELLORS = 'VIEW_COUNSELLORS',
  ADD_COUNSELLOR = 'ADD_COUNSELLOR',
  DELETE_COUNSELLOR = 'DELETE_COUNSELLOR',
  MANAGE_RESOURCES = 'MANAGE_RESOURCES',
  EXPORT_ANALYTICS = 'EXPORT_ANALYTICS'
}

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  [UserRole.SUPER_ADMIN]: [
    Permission.VIEW_USERS,
    Permission.INVITE_USER,
    Permission.CHANGE_USER_ROLE,
    Permission.DELETE_USER,
    Permission.VIEW_CASES,
    Permission.VIEW_SESSIONS,
    Permission.VIEW_COUNSELLORS,
    Permission.ADD_COUNSELLOR,
    Permission.DELETE_COUNSELLOR,
    Permission.MANAGE_RESOURCES,
    Permission.EXPORT_ANALYTICS
  ],
  [UserRole.ADMIN]: [
    Permission.VIEW_USERS,
    Permission.VIEW_CASES,
    Permission.VIEW_SESSIONS,
    Permission.VIEW_COUNSELLORS,
    Permission.DELETE_COUNSELLOR,
    Permission.MANAGE_RESOURCES,
    Permission.EXPORT_ANALYTICS
  ],
  [UserRole.SUPERVISOR]: [
    Permission.VIEW_USERS,
    Permission.VIEW_CASES,
    Permission.VIEW_SESSIONS,
    Permission.VIEW_COUNSELLORS,
    Permission.ADD_COUNSELLOR,
    Permission.DELETE_COUNSELLOR,
    Permission.MANAGE_RESOURCES,
    Permission.EXPORT_ANALYTICS
  ],
  [UserRole.RESEARCHER]: [],
  [UserRole.EMERGENCY_RESPONDER]: [],
  [UserRole.COUNSELLOR]: [],
  [UserRole.PATIENT]: [],
  [UserRole.SYSTEM]: []
};

export interface StoredUser {
  _id?: string;
  role?: UserRole | string;
  name?: string;
  email?: string;
  [key: string]: unknown;
}

export const getCurrentUser = (): StoredUser | null => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw) as StoredUser;
  } catch {
    return null;
  }
};

export const getCurrentRole = (): UserRole | null => {
  const user = getCurrentUser();
  if (!user || !user.role) return null;
  const role = user.role as string;
  return (Object.values(UserRole) as string[]).includes(role)
    ? (role as UserRole)
    : null;
};

export const hasPermission = (
  role: UserRole | null | undefined,
  permission: Permission
): boolean => {
  if (!role) return false;
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
};
